module.exports = __webpack_public_path__ + "static/media/twitter.9579e6fc.svg";